<template>
  <q-menu
    class="overflow-x-hidden w-[300px] flex flex-col gap-8 p-8 !mt-10 border border-neutral-100/5"
  >
    <div class="bg-neutral-2 flex flex-col gap-8 rounded p-16">
      <img
        v-if="
          (user?.staff || user?.superuser) && assessment?.logo_png
        "
        :src="assessment?.logo_png"
        :alt="assessment?.nome_fantasia"
        class="w-fit h-40 object-contain"
      />

      <img
        v-else-if="user?.foto"
        :src="user?.foto"
        :alt="user?.fabricante"
        class="w-fit h-40 object-contain"
      />

      <h3 class="text-headline-3 text-neutral-100 !capitalize">
        {{ nome }}
      </h3>

      <p
        v-if="user?.staff || user?.superuser"
        class="text-paragraph-3 text-neutral-70"
      >
        {{ t('userAdmin') }}
      </p>
      <p v-else class="text-paragraph-3 text-neutral-70">
        {{ t('bottler') }}: {{ user?.fabricante || '-' }}
      </p>
    </div>

    <div v-if="showLanguages" class="flex flex-col">
      <OSelect
        v-model="model"
        :options="options"
        size="md"
        class="text-paragraph-3 w-full transition-colors h-48 !border-neutral-100/10 bg-white !border-0 !mb-0"
        @update:modelValue="onUpdateLanguage"
      >
        <template #selected>
          <q-item class="items-center gap-8 !px-4">
            <q-icon size="1.5rem" :name="`svguse:#${model.icon}`" />
            <p>{{ model.label }}</p>
          </q-item>
        </template>

        <template #option="scope">
          <q-item v-bind="scope.itemProps">
            <q-item-section avatar>
              <q-icon :name="`svguse:#${scope.opt.icon}`" />
            </q-item-section>
            <q-item-section>
              <q-item-label>
                {{ scope.opt.label }}
              </q-item-label>
            </q-item-section>
          </q-item>
        </template>
      </OSelect>

      <p class="text-paragraph-4 text-neutral-70">
        {{ t('theSelectedLanguageText') }}
      </p>
    </div>

    <q-list class="select-none w-full">
      <q-item
        tag="a"
        :href="logoutUrl"
        class="rounded-md hover:text-neutral-60 px-24 py-16"
      >
        <q-item-section
          class="flex flex-row items-center !justify-start gap-8"
        >
          <IconLogout class="size-24 text-neutral-70" />
          <span class="text-headline-3 text-neutral-100">
            {{ t('exit') }}
          </span>
        </q-item-section>
      </q-item>
    </q-list>
  </q-menu>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'
import IconLogout from 'public/icons/logout.svg'
import OSelect from 'components/Select/OSelect.vue'
import useProfile from 'composables/useProfile'

const { t } = useI18n()
const { setLanguageProfile } = useProfile()
const context = inject('context')

/** @typedef {import('../../types/assessment').AssessmentTypes} AssessmentTypes */

/** @type {{assessment:AssessmentTypes}} */
const { user, assessment } = defineProps({
  user: Object,
  assessment: Object,
  showLanguages: { type: Boolean, default: false },
})

const model = ref({})

const options = ref([
  { label: 'Inglês', value: 'EN', icon: 'icon_flag-us' },
  { label: 'Espanhol', value: 'ES', icon: 'icon_flag-es' },
  {
    label: 'Português - BR',
    value: 'PT',
    icon: 'icon_flag-br',
  },
])

const nome = computed(
  () => user?.nome || user?.first_name || user?.username
)

const logoutUrl = computed(() => {
  if (assessment?.slug) return `/logout/?slug=${assessment.slug}`
  return '/logout/'
})

function onUpdateLanguage(option) {
  model.value = option
  setLanguageProfile(option.value)
}

onMounted(() => {
  const lang = context.user?.linguagem
  const selectedOption = options.value.find(
    (opt) => opt.value === lang
  )
  model.value = selectedOption
})
</script>

<style lang="sass" scoped></style>
